import { DISPLAY_STATUS, type DisplayStatusType, OrderStatus } from '@constants'

/**
 * 暫解：後端尚未回傳 display_status 時，前端根據 order status 推導。
 * 待後端補上 display_status 欄位後應移除此 function。
 *
 * 注意：型別未從 @hooks-api import 以避免 utils ↔ hooks-api circular dependency。
 */
// sync with: libs/hooks-api/src/types/dataModel/eCommerceOrders.ts refundStatus
const REFUNDED_REFUND_STATUSES = new Set<string>(['refunded', 'manual_refund', 'refund_failed'])

interface DeriveDisplayStatusParams {
  status: string
  refundStatus?: string | null
  relatedOrderStatuses?: string[]
}

export function deriveDisplayStatus({ status, refundStatus, relatedOrderStatuses }: DeriveDisplayStatusParams): DisplayStatusType {
  if (status === OrderStatus.PENDING) return DISPLAY_STATUS.PENDING_PAYMENT
  if (status === OrderStatus.CANCELLED) return DISPLAY_STATUS.CANCELLED
  if (refundStatus && REFUNDED_REFUND_STATUSES.has(refundStatus)) return DISPLAY_STATUS.REFUNDED
  if (status === OrderStatus.COMPLETED) return DISPLAY_STATUS.SHIPPED
  if (status === OrderStatus.READY_FOR_SHIPMENT) return DISPLAY_STATUS.PREPARING_SHIPMENT
  if (status === OrderStatus.PROCESSING && relatedOrderStatuses?.some(relatedStatus => relatedStatus === OrderStatus.READY_FOR_SHIPMENT)) return DISPLAY_STATUS.PREPARING_SHIPMENT
  return DISPLAY_STATUS.PENDING_SHIPMENT
}
